import setupEmailField from "JIX/jix_email_field.js";

const stashes = window.Stash['widgets/jix_email_field'];

stashes.forEach(({ id, stash }) => {
    const input = document.getElementById(id);
    setupEmailField(input, stash);
});
